<template>
  <div>
    <login
      :department="department"
      @submitClick="submitClick"
      @loginSuccess="loginSuccess"
    />
  </div>
</template>
<script>
import login from '@/views/login.vue'
export default {
  components: { login },
  data() {
    return {}
  },
  computed: {
    department() {
      return this.$store.state.official.department
    },
    keyfrom() {
      return this.$store.state.official.keyfrom
    },
  },
  mounted() {
    this.frogReport('/event/mRecurimentLogin/pageView')
  },
  methods: {
    submitClick() {
      this.frogReport('/click/mRecurimentLogin/submit')
    },
    loginSuccess() {
      // 进入“我的投递进度”页面埋点
      this.frogReport('/event/mRecurimentLogin/goMyProgress')
    },
    frogReport(url, extra = []) {
      this.$addFrog(1531, url, [
        { key: 'keyfrom', value: this.keyfrom },
        ...extra,
      ])
    },
  },
}
</script>
<style lang="less" scoped></style>
